import { render, staticRenderFns } from "./DeliverSearchDetail.vue?vue&type=template&id=afe9c67e&scoped=true&"
import script from "./DeliverSearchDetail.vue?vue&type=script&lang=js&"
export * from "./DeliverSearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliverSearchDetail.vue?vue&type=style&index=0&id=afe9c67e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe9c67e",
  null
  
)

export default component.exports